import GetValidationErrorMessageHandler from '@/services/GetValidationErrorMessageHandler';

export default ({ app }, inject) => {
    inject(
        'getValidationErrorMessageHandler',
        new GetValidationErrorMessageHandler(app)
    );
};
